import React from "react";
import { globalEnvironmentConfig } from "global-environment-config";
import { isDevEnv } from "shared/data";

const ImageItem = (props) => {
    const { imageId, text } = props.data;
    const onSelect = () => {
        if (props.updateOnChange) {
            props.updateOnChange(props.data, props.isActive);
        }
    };
    const cssClass = props.isActive ? "image-item -active" : "image-item";
    const src = isDevEnv()
        ? `/api${props.provider}/images/${imageId}`
        : `${globalEnvironmentConfig.ApiBaseUrl}/api${props.provider}/images/${imageId}`;

    return (
        <div
            className={cssClass}
            onClick={onSelect}
        >
            <img
                src={src}
                alt={text}
                title={text}
            />
        </div>
    );
};

export default ImageItem;
